import { useEffect, useState, useCallback } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/lib/auth/AuthProvider";
import type { Profile } from "./types";

export const useProfile = () => {
  const { user } = useAuth();
  const [profile, setProfile] = useState<Profile | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!user) {
      setProfile(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", user.id)
      .maybeSingle();
    if (error) setError(error.message);
    setProfile((data as unknown as Profile | null) ?? null);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    void load();
  }, [load]);

  const update = useCallback(
    async (patch: Partial<Profile>) => {
      if (!user) return { error: "Not signed in" };
      const { data, error } = await supabase
        .from("profiles")
        .update(patch as any)
        .eq("id", user.id)
        .select("*")
        .maybeSingle();
      if (error) return { error: error.message };
      setProfile(data as unknown as Profile);
      return { data: data as unknown as Profile };
    },
    [user],
  );

  return { profile, loading, error, reload: load, update };
};
